/**
 * Input — Themed text input element
 *
 * Variants:
 *   - size: sm, md, lg
 *   - error: true/false (red border)
 */
import { styled, Input as TamaguiInput } from 'tamagui'

export const Input = styled(TamaguiInput, {
  name: 'Input',
  bg: '$backgroundInput',
  br: '$lg',
  bw: 2,
  bc: '$borderColor',
  color: '$color',
  px: '$md',
  py: '$md',
  h: 57,
  fontSize: 16,
  placeholderTextColor: '$colorMuted',
  focusStyle: {
    bc: '$borderColorFocus',
    bw: 2,
  },

  variants: {
    size: {
      sm: {
        px: '$sm',
        py: '$sm',
        fontSize: 14,
        br: '$sm',
      },
      md: {
        px: '$md',
        py: '$md',
        fontSize: 16,
      },
      lg: {
        px: '$md',
        py: '$lg',
        fontSize: 16,
      },
    },

    error: {
      true: {
        bc: '$colorError',
        focusStyle: {
          bc: '$colorError',
          bw: 2,
        },
      },
    },
  } as const,

  defaultVariants: {
    size: 'md',
  },
})
